export default __webpack_public_path__ + "static/media/2ET0EkBwv5lbLlGv.9ad23908.jpg";